import type { CardConfiguration, CoreConfiguration } from '@adyen/adyen-web';

import { getLocale } from '@libs/core';

// https://github.com/Adyen/adyen-web/blob/c6c19ac646a8a211d0416a462b2c2a2a722eff29/packages/lib/src/language/locales/en-US.json -- Possible Adyen translations
export const adyenTranslations = {
    'en-US': {
        'creditCard.cvcField.title': '',
        'creditCard.expiryDateField.title': '',
        'creditCard.holderName': '',
        'creditCard.numberField.title': '',
        'creditCard.holderName.invalid': 'Name on card is required',
        'error.va.sf-cc-num.01': 'Card number is not valid',
        'error.va.sf-cc-num.02': 'Card number is required',
        'error.va.sf-cc-num.03': 'Enter a supported card brand',
        'error.va.sf-cc-num.04': 'Card number is the wrong length',
        'error.va.sf-cc-dat.01': 'Expiry date: card too old',
        'error.va.sf-cc-dat.02': 'Expiry date: date too far in the future',
        'error.va.sf-cc-dat.04': 'Expiration is required',
        'error.va.sf-cc-dat.05': 'Expiry date is the wrong length',
        'error.va.sf-cc-cvc.01': 'CVV is required',
        'error.va.sf-cc-cvc.02': 'Security code is the wrong length',
    },
    'en-CA': {
        'creditCard.cvcField.title': '',
        'creditCard.expiryDateField.title': '',
        'creditCard.holderName': '',
        'creditCard.numberField.title': '',
        'creditCard.holderName.invalid': 'Name on card is required',
        'error.va.sf-cc-num.01': 'Card number is not valid',
        'error.va.sf-cc-num.02': 'Card number is required',
        'error.va.sf-cc-num.03': 'Enter a supported card brand',
        'error.va.sf-cc-num.04': 'Card number is the wrong length',
        'error.va.sf-cc-dat.01': 'Expiry date: card too old',
        'error.va.sf-cc-dat.02': 'Expiry date: date too far in the future',
        'error.va.sf-cc-dat.04': 'Expiration is required',
        'error.va.sf-cc-dat.05': 'Expiry date is the wrong length',
        'error.va.sf-cc-cvc.01': 'CVV is required',
        'error.va.sf-cc-cvc.02': 'Security code is the wrong length',
    },
};

export const adyenBaseConfiguration = {
    analytics: {
        enabled: false,
    },
    clientKey: process.env.NEXT_PUBLIC_ADYEN_CLIENT_KEY,
    environment: process.env.NEXT_PUBLIC_ADYEN_ENVIRONMENT as CoreConfiguration['environment'],
    locale: getLocale(),
    translations: adyenTranslations,
} satisfies CoreConfiguration;

export const adyenCardStyles = {
    base: {
        fontFamily: 'sans-serif',
        fontSize: '16px',
    },
    placeholder: {
        fontFamily: 'sans-serif',
        fontSize: '16px',
        fontWeight: '400',
        color: '#131313',
    },
};

// Placeholders are no longer part of the translations object in Adyen Web v6.
export const adyenCardPlaceholders: CardConfiguration['placeholders'] = {
    cardNumber: 'Card number',
    expiryDate: 'Exp MM/YY',
    securityCodeThreeDigits: 'CVV',
    securityCodeFourDigits: 'CVV',
    holderName: 'Name on card',
};
